import { Modal, Button } from 'react-bootstrap';
import { XCircle } from 'react-bootstrap-icons';

interface ErrorModalProps {
    show: boolean;
    onHide: () => void;
    message: string;
}

export function ErrorModal({ show, onHide, message }: ErrorModalProps) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header className="border-0">
                <Modal.Title className="d-flex align-items-center gap-2 text-danger">
                    <XCircle size={24} />
                    Error
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-0">{message}</p>
            </Modal.Body>
            <Modal.Footer className="border-0">
                <Button variant="primary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
} 